import React from "react";
import { Image, LinkBox, Box, Section, Text } from "@quarkly/widgets";
import { Override } from "@quarkly/components";

import image_sponcollab_solspaces from "../assets/logos_sponsors_collabs/solspaces.png";
import image_sponcollab_shell from "../assets/logos_sponsors_collabs/shell.png";
import image_sponcollab_enguofa from "../assets/logos_sponsors_collabs/engineering_ualberta.jpg";
import image_sponcollab_georgeford from "../assets/logos_sponsors_collabs/george-ford.jpg";
import image_sponcollab_emso from "../assets/logos_sponsors_collabs/emso.jpg";

const Sponsors = () => (
  <>
    <Section padding="60px 0 40px 0" quarkly-title="Section_Sponsors_Title">
      <Box
        md-width="100%"
        empty-min-width="64px"
        empty-min-height="64px"
        empty-border-width="1px"
        empty-border-style="solid"
        empty-border-color="LightGray"
        width="100%"
        display="flex"
        align-self="auto"
        flex="1 1 0%"
        align-items="center"
        justify-content="center"
        flex-direction="column"
        flex-wrap="no-wrap"
      >
        <Text
          margin="0px 0px 40px 0px"
          color="--light"
          font="--headline2"
          lg-font="normal 500 32px/1.2 --fontFamily-googleAlegreyaSans, sans-serif"
          md-margin="0px 0px 16px 0px"
        >
          Our Sponsors
        </Text>
        <Text
          color="--light"
          font="--base"
          lg-font='normal 400 16px/1.5 "Varta", sans-serif'
          margin="0px 0px 0px 0px"
          text-align="left"
        >
          Thanks to all the organizations that have supported us!
        </Text>
      </Box>
    </Section>
    <Section
      padding="40px 0 40px 0"
      md-padding="20px 0 12px 0"
      quarkly-title="Section_Sponsors_Content1"
    >
      <Override
        slot="SectionContent"
        flex-direction="row"
        md-flex-wrap="wrap"
      />
      <Box
        empty-border-width="1px"
        empty-border-style="solid"
        width="50%"
        md-width="100%"
        md-padding="0px 0px 0px 0px"
        empty-min-width="64px"
        empty-min-height="64px"
        empty-border-color="LightGray"
        padding="0px 0px 0px 20px"
      >
        <LinkBox target="_blank" href="https://www.solspaces.com/">
          <Image
            src={image_sponcollab_solspaces}
            max-height="400px"
            width="90%"
            object-fit="cover"
            lg-max-height="230px"
            height="100%"
            overflow="visible"
            flex="1 1 0%"
            display="inline-block"
            overflow-x="visible"
            overflow-y="visible"
            srcSet={`${image_sponcollab_solspaces} 500w, ${image_sponcollab_solspaces} 800w, ${image_sponcollab_solspaces} 1080w, ${image_sponcollab_solspaces} 1600w, ${image_sponcollab_solspaces} 2000w, ${image_sponcollab_solspaces} 2600w, ${image_sponcollab_solspaces} 3200w`}
            sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,100vw"
          />
          <Text
            margin="32px 0px 16px 0px"
            font="--lead"
            color="--green"
            lg-font='normal 600 20px/1.5 "Varta", sans-serif'
            md-margin="12px 0px 16px 0px"
            sm-margin="24px 0px 16px 0px"
            text-align="center"
          >
            Sol Spaces (incorporates Exceed Solar)
          </Text>
        </LinkBox>
      </Box>
      <Box
        empty-border-width="1px"
        empty-border-style="solid"
        width="50%"
        md-width="100%"
        md-padding="0px 0px 0px 0px"
        empty-min-width="64px"
        empty-min-height="64px"
        empty-border-color="LightGray"
        padding="0px 0px 0px 20px"
      >
        <LinkBox target="_blank" href="https://www.shell.ca/">
          <Image
            src={image_sponcollab_shell}
            max-height="400px"
            width="85%"
            object-fit="cover"
            lg-max-height="230px"
            height="100%"
            overflow="visible"
            flex="1 1 0%"
            display="inline-block"
            overflow-x="visible"
            overflow-y="visible"
            srcSet={`${image_sponcollab_shell} 500w, ${image_sponcollab_shell} 800w, ${image_sponcollab_shell} 1080w, ${image_sponcollab_shell} 1600w, ${image_sponcollab_shell} 2000w, ${image_sponcollab_shell} 2600w, ${image_sponcollab_shell} 3200w`}
            sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,100vw"
          />
          <Text
            margin="32px 0px 16px 0px"
            font="--lead"
            color="--green"
            lg-font='normal 600 20px/1.5 "Varta", sans-serif'
            md-margin="12px 0px 16px 0px"
            sm-margin="24px 0px 16px 0px"
            text-align="center"
          >
            Shell
          </Text>
        </LinkBox>
      </Box>
      <Box
        empty-border-width="1px"
        empty-border-style="solid"
        width="50%"
        md-width="100%"
        md-padding="0px 0px 0px 0px"
        empty-min-width="64px"
        empty-min-height="64px"
        empty-border-color="LightGray"
        padding="0px 0px 0px 20px"
      >
        <LinkBox
          target="_blank"
          href="https://www.ualberta.ca/en/experiential-learning/opportunities/engineering-student-projects-esps.html"
        >
          <Image
            src={image_sponcollab_enguofa}
            max-height="400px"
            width="83%"
            object-fit="cover"
            lg-max-height="230px"
            overflow="visible"
            height="100%"
            flex="1 1 0%"
            display="inline-block"
            overflow-x="visible"
            overflow-y="visible"
            srcSet={`${image_sponcollab_enguofa} 500w, ${image_sponcollab_enguofa} 800w, ${image_sponcollab_enguofa} 1080w, ${image_sponcollab_enguofa} 1600w, ${image_sponcollab_enguofa} 2000w, ${image_sponcollab_enguofa} 2600w, ${image_sponcollab_enguofa} 3200w`}
            sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,100vw"
          />
          <Text
            margin="32px 0px 16px 0px"
            font="--lead"
            color="--green"
            lg-font='normal 600 20px/1.5 "Varta", sans-serif'
            md-margin="12px 0px 16px 0px"
            sm-margin="24px 0px 16px 0px"
            text-align="center"
          >
            UAlberta Engineering
          </Text>
        </LinkBox>
      </Box>
    </Section>
    <Section
      padding="40px 0 40px 0"
      md-padding="20px 0 12px 0"
      quarkly-title="Section_Sponsors_Content2"
      justify-content="center"
    >
      <Override
        slot="SectionContent"
        flex-direction="row"
        md-flex-wrap="wrap"
      />
      <Box
        empty-border-width="1px"
        empty-border-style="solid"
        width="50%"
        md-width="100%"
        md-padding="0px 0px 0px 0px"
        empty-min-width="64px"
        empty-min-height="64px"
        empty-border-color="LightGray"
        padding="0px 0px 0px 20px"
      >
        <LinkBox
          target="_blank"
          href="https://www.ualberta.ca/en/engineering/about/news/2023/february/three-ways-one-profs-passion-is-shaping-the-future-of-engineering.html"
        >
          <Image
            src={image_sponcollab_georgeford}
            max-height="400px"
            lg-max-height="230px"
            width="75%"
            object-fit="cover"
            overflow="hidden"
            srcSet={`${image_sponcollab_georgeford} 500w, ${image_sponcollab_georgeford} 800w, ${image_sponcollab_georgeford} 1080w, ${image_sponcollab_georgeford} 1600w, ${image_sponcollab_georgeford} 2000w, ${image_sponcollab_georgeford} 2600w, ${image_sponcollab_georgeford} 3200w`}
            sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,100vw"
          />
          <Text
            margin="32px 0px 16px 0px"
            font="--lead"
            color="--green"
            lg-font='normal 600 20px/1.5 "Varta", sans-serif'
            md-margin="12px 0px 16px 0px"
            sm-margin="24px 0px 16px 0px"
            text-align="center"
          >
            Spirit of George Ford Fund
          </Text>
        </LinkBox>
      </Box>
      <Box
        empty-border-width="1px"
        empty-border-style="solid"
        width="50%"
        md-width="100%"
        md-padding="0px 0px 0px 0px"
        empty-min-width="64px"
        empty-min-height="64px"
        empty-border-color="LightGray"
        padding="0px 0px 0px 20px"
      >
        <LinkBox
          target="_blank"
          href="https://www.ualberta.ca/en/university-services-operations-finance/initiatives/energy-climate-action/index.html"
        >
          <Image
            src={image_sponcollab_emso}
            max-height="400px"
            width="75%"
            object-fit="cover"
            lg-max-height="230px"
            overflow="hidden"
            srcSet={`${image_sponcollab_emso} 500w, ${image_sponcollab_emso} 800w, ${image_sponcollab_emso} 1080w, ${image_sponcollab_emso} 1600w, ${image_sponcollab_emso} 2000w, ${image_sponcollab_emso} 2600w, ${image_sponcollab_emso} 3200w`}
            sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,100vw"
          />
          <Text
            margin="32px 0px 16px 0px"
            font="--lead"
            color="--green"
            lg-font='normal 600 20px/1.5 "Varta", sans-serif'
            md-margin="12px 0px 16px 0px"
            sm-margin="24px 0px 16px 0px"
            text-align="center"
          >
            Energy Management and Sustainable Operations (EMSO)
          </Text>
        </LinkBox>
      </Box>
      <Box
        empty-border-width="0px"
        empty-border-style="solid"
        width="50%"
        md-width="100%"
        md-padding="0px 0px 0px 0px"
        empty-min-width="64px"
        empty-min-height="64px"
        empty-border-color="LightGray"
        padding="0px 0px 0px 20px"
      />
    </Section>
  </>
);

export default Sponsors;
